<template>
  <form
    ref="form"
    data-url="/complianceCommitmenttechnicalreview/store"
    :class="{ 'loading-opacity': preloader }"
  >
    <div class="row">
      <div class="col-md-12">
        <legend>
          <p class="text-primary">
            VERIFICACIÓN DE LA DOCUMENTACIÓN RECIBIDA Y ALCANCE SOLICITADO
          </p>
        </legend>
        <app-note
          note-type="note-red"
          :show-title="false"
          :notes="formNoteInstruction"
        />
        <br />
        <table id="compliance-commitment">
          <tr>
            <td class="name">El alcance solicitado es el apropiado <strong class="text-danger">*</strong></td>
            <td class="is-checked">
              <app-input
                type="radio-buttons"
                v-model="inputs.requested_scope_is_appropriate"
                :list="list"
              />
            </td>
          </tr>
          <tr>
            <td class="name">
              Existe al menos UN alcance de acreditación nuevo para el SAE <strong class="text-danger">*</strong>
            </td>
            <td class="is-checked">
              <app-input
                type="radio-buttons"
                v-model="inputs.new_scope_accreditation"
                :list="list"
              />
            </td>
          </tr>
          <tr>
            <td class="name">
              El alcance solicitado requiere el desarrollo de un esquema <strong class="text-danger">*</strong> <br />
              <small
                >(PG06 Procedimiento General Nuevos esquemas de acreditación e
                idoneidad de EEC)</small
              >
            </td>
            <td class="is-checked">
              <app-input
                type="radio-buttons"
                v-model="inputs.requires_development"
                :list="list"
              />
            </td>
          </tr>
        </table>
      </div>
    </div>
    <br />
    <hr />

    <!-- <div class="row"> -->
    <!-- <div class="col-12"> -->
    <div class="form-group">
      <label>
        {{
          $t(
            "Si el alcance no es apropiado describir las razones (En caso que aplique)"
          )
        }}
      </label>
      <quill-editor
        v-model="inputs.description_scope"
        :options="editorOption"
      />
    </div>
    <!-- </div>
    </div> -->
    <div class="row">
      <div class="col-12">
        <button class="btn btn-primary" :disabled="disabledsupport" @click.prevent="submit">Guardar</button>
      </div>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "ComplianceCommitment",
  mixins: [FormMixin],
  components: { quillEditor },
  data() {
    return {
      preloader: false,
      inputs: {},
      attached_file: {},
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      formNoteInstruction: [
        this.$t("Todos los campos con un (*) son obligatorios."),
      ],
      deleteModal: false,
      delete_file: false,
      formRowInstruction1: [this.$t("compliance_commitment_statement")],
      pdf: "/common/pdf/complianceCommitment?accreditation_application_id=",
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      },
    };
  },
  computed: {
    status() {
      return this.$store.state.accreditation.app != null &&
        this.$store.state.accreditation.app.status != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },

    disabled() {
      return this.status != null && this.status != "112";
    },
  },

  created() {
    this.data();
    this.disabledsupport = localStorage.getItem("auth_id") === "true"; 
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      var request = {};
      request[
        "requested_scope_is_appropriate"
      ] = this.inputs.requested_scope_is_appropriate;
      request["new_scope_accreditation"] = this.inputs.new_scope_accreditation;
      request["requires_development"] = this.inputs.requires_development;
      request["description_scope"] = this.inputs.description_scope;
      request[
        "accreditation_application_id"
      ] = this.$store.state.accreditation.id;

      this.save(request);
    },

    afterSuccess(res) {
      this.$toastr.s("Registrado con éxito");
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;

      this.axiosGet(
        `${actions.COMPLIANCE_COMMITMENT}/show?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          this.inputs = response.data ? response.data : {};
        })
        .catch((error) => {
          console.log("ComplianceCommitment: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    confirmed() {
      this.deleteModal = false;
      this.inputs.file = null;
      this.attached_file = null;
      this.delete_file = true;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab() {
      window.open(this.attached_file, "_blank");
    },
  },
};
</script>
<style lang="css">
#compliance-commitment {
  width: 100%;
}
#compliance-commitment tr {
  border: 1px dotted gray;
}
#compliance-commitment td {
  padding: 0.8rem;
}
#compliance-commitment .name {
  text-align: justify;
}
#compliance-commitment .is-checked {
  width: 20%;
  text-align: right;
}
</style>